module.exports = __webpack_public_path__ + "static/media/122.802a3faf.jpg";